import { render, staticRenderFns } from "./BarcodeFilter.vue?vue&type=template&id=b52a9bee&"
import script from "./BarcodeFilter.vue?vue&type=script&lang=js&"
export * from "./BarcodeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports